var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateSingleInput',_vm._b({attrs:{"value":_vm.cycleDateValue,"is-disabled":_vm.$attrs.disabled,"has-input-error":_vm.hasInputError},on:{"input":_vm.handleInput,"change":_vm.handleChange}},'DateSingleInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }